module.exports = __webpack_public_path__ + "static/artist-management-banner-77a60812b06d04313c01d5a897dc5aff.png";